import { ensureFoodProfileConditions } from './foodProfile';

export const TOGGLE_FOODPROFILE_POPUP = 'TOGGLE_FOODPROFILE_POPUP';
export const SET_FOODPROFILE_POPUP_STEP = 'SET_FOODPROFILE_POPUP_STEP';
export const SHOW_FOODPROFILE_POPUP = 'SHOW_FOODPROFILE_POPUP';
export const HIDE_FOODPROFILE_POPUP = 'HIDE_FOODPROFILE_POPUP';

export function toggleFoodProfilePopup() {
  return {
    type: TOGGLE_FOODPROFILE_POPUP,
  };
}

export function showFoodProfilePopup(step = 0) {
  return (dispatch) => dispatch(ensureFoodProfileConditions()).then(
    () => dispatch({
      type: SHOW_FOODPROFILE_POPUP,
      data: step,
    })
  );
}

export function hideFoodProfilePopup() {
  return {
    type: HIDE_FOODPROFILE_POPUP,
  };
}

export function setFoodProfilePopupStep(step) {
  return {
    type: SET_FOODPROFILE_POPUP_STEP,
    data: step,
  };
}
